<app-user-select
  [userList]="userList"
  (userChange)="onUserChange($event)"
></app-user-select>
<ng-container *ngIf="userBasicInfo$ | async as userBasicInfo">
  <app-basic-info [userBasicInfo]="userBasicInfo"></app-basic-info>
</ng-container>
